var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0004 2.33594C10.9437 2.33594 8.45874 4.82094 8.45874 7.8776C8.45874 10.8759 10.8037 13.3026 13.8604 13.4076C13.9537 13.3959 14.0471 13.3959 14.1171 13.4076C14.1404 13.4076 14.1521 13.4076 14.1754 13.4076C14.1871 13.4076 14.1871 13.4076 14.1987 13.4076C17.1854 13.3026 19.5304 10.8759 19.5421 7.8776C19.5421 4.82094 17.0571 2.33594 14.0004 2.33594Z",
    fill: "#2E37A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.9264 16.5103C16.6714 14.3403 11.363 14.3403 8.08471 16.5103C6.60304 17.502 5.78638 18.8436 5.78638 20.2786C5.78638 21.7136 6.60304 23.0436 8.07304 24.0236C9.70638 25.1203 11.853 25.6686 13.9997 25.6686C16.1464 25.6686 18.293 25.1203 19.9264 24.0236C21.3964 23.032 22.213 21.702 22.213 20.2553C22.2014 18.8203 21.3964 17.4903 19.9264 16.5103Z",
    fill: "#2E37A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3329 19.4036H14.8746V17.9453C14.8746 17.467 14.4779 17.0703 13.9996 17.0703C13.5213 17.0703 13.1246 17.467 13.1246 17.9453V19.4036H11.6663C11.1879 19.4036 10.7913 19.8003 10.7913 20.2786C10.7913 20.757 11.1879 21.1536 11.6663 21.1536H13.1246V22.612C13.1246 23.0903 13.5213 23.487 13.9996 23.487C14.4779 23.487 14.8746 23.0903 14.8746 22.612V21.1536H16.3329C16.8113 21.1536 17.2079 20.757 17.2079 20.2786C17.2079 19.8003 16.8113 19.4036 16.3329 19.4036Z",
    fill: "#2E37A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAdd);
export default __webpack_public_path__ + "static/media/profile-add.89058500ae4ee95817dc4b805f7fb817.svg";
export { ForwardRef as ReactComponent };